import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { AdvertisementProvider } from "../../../context/AdvertisementContext";
import { PositionProvider } from "../../../context/PositionContext";

export const DoseeAds = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddDoseeAd = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditDoseeAd = () => {
  return (
    
      <AdvertisementProvider>
        
          <Edit />
        
      </AdvertisementProvider>
    
  );
};
